<button
  pButton
  class="m-button"
  [disabled]="disabled"
  [style]="style"
  [ngClass]="styleClass"
  [severity]="primengSeverity"
  [text]="isText"
  [loading]="loading"
  [icon]="icon"
  [label]="label"
  [attr.aria-label]="ariaLabel">
  <ng-content></ng-content>
</button>
